import ErrorPage from "src/pages/error/error-page"
import Home from "src/pages/home/Home";

const HomeRoutes = {
    path: "/",
    element:<Home />,
    errorElement: <ErrorPage />
  }

  export default HomeRoutes